import { forwardRef, Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie';
import jwt_decode from 'jwt-decode';
import {ToastrService } from 'ngx-toastr';
import { switchMap, tap } from 'rxjs/operators';
// import { SiteService } from './site.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user: any;
  siteId: any = 0;
  siteCultures: any = [];

  constructor(
    private snotifyService: ToastrService,
    private router: Router,
    private httpClient: HttpClient,
    private cookieService: CookieService,
    // private siteService: SiteService
    // @Inject(forwardRef(() => SiteService)) private siteService: SiteService
  ) {
  
  }

  isLoggedIn() {
    return this.cookieService.get("admin_access_token") ? true : false
  }


  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2500,
   progressBar: true,
      tapToDismiss: true
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
      timeOut: 2500,
      progressBar: true,
         tapToDismiss: true
    });
  }
  loggeIn(username, password) {

    let LoginObj = {
      Username: username,
      Password: password,
      RememberMe: true
    };


    return this.httpClient.post('/admin/login', LoginObj)
      .pipe(
        tap((result) => {

          const jsonResult = result as any;

          if (jsonResult.isCoreIntegration === true) {
            localStorage.setItem('coreIntegration', 'true');
            localStorage.setItem('coreToken', jsonResult.coreLoginResponse.coreAuthToken);
            localStorage.setItem('coreRefreshToken', jsonResult.coreLoginResponse.coreRefreshToken);
            localStorage.setItem('coreSessionId', jsonResult.coreLoginResponse.coreSessionId);
            localStorage.setItem('coreUsername', jsonResult.coreLoginResponse.coreUsername);
            //this.integrationService.updateEskaCoreMenus(jsonResult.eskaCoreMenus);
          }

          let data = {
            Culture: '',
            DefaultSiteCultures: [],
            DefaultSiteInfo: { siteId: result['siteId'], isDefault: result['isDefault'] },
            isDefault: result['isDefault'],
            site: { id: result['siteId'] },
            siteId: result['siteId'],
            Role: {},
            RoleInfo: result['optionsCodes'],
          }

          localStorage.setItem('userData', JSON.stringify(data));

          const requestOptions = {
            headers: new HttpHeaders({
              SiteId: result['siteId'] + ''
            }),
          };

          

        

          //  this.user = this.getLoggedUser()
          this.siteId = result['siteId']
          // this.siteCultures = this.getLoggedUser().siteCultures;
          //  return this.httpClient.post('/token/create?includeRefreshToken=true', LoginObj, requestOptions)
          return result;
        }),
        tap((results) => {
          this.cookieService.put('admin_access_token', results['token'].token, { sameSite: 'strict' });
          this.cookieService.put('admin_refresh_token', results['token'].refreshToken, { sameSite: 'strict' });
        
          // this.cookieService.put('admin_access_token', res['token'], { sameSite: 'strict' });
          // this.cookieService.put('admin_refresh_token', res['refreshToken'], { sameSite: 'strict' });
          //  this.user = this.getLoggedUser()
          this.siteId = results['siteId']
          // this.siteCultures = this.getLoggedUser().siteCultures;
        })
      )

  }
  public forgotPassword(reqBody) {
    return this.httpClient.post(`/admin/ForgotPassword`, reqBody);
  }

  refreshToken() {
    let tokenObject = {
      Token: this.cookieService.get('admin_access_token'),
      RefreshToken: this.cookieService.get('admin_refresh_token')
    }
    return this.httpClient.post('/token/refresh', tokenObject)
      .pipe(tap((res: any) => {
        this.cookieService.put('admin_access_token', res.token, { sameSite: 'strict' });
        this.cookieService.put('admin_refresh_token', res.refreshToken, { sameSite: 'strict' });
        this.user = this.getLoggedUser()
        this.siteId = this.getLoggedUser()['siteId']
        this.siteCultures = this.getLoggedUser()['siteCultures']
        // this.siteService.reset();
        // this.router.navigate(['Dashboard']);
      }, error => {
        this.sessionTimeout();
      }
      ));

    // .subscribe((res: any) => {
    //   console.log(res);
    //   this.cookieService.put('admin_access_token', res.token, { secure: true });
    //   this.cookieService.put('admin_refresh_token', res.refreshToken, { secure: true });
    //   this.user = this.getLoggedUser()
    //   this.siteId = this.getLoggedUser()['siteId']
    //   this.siteCultures = this.getLoggedUser()['siteCultures'] 
    //   this.router.navigate(['Dashboard']);
    // }, error => {
    //   this.sessionTimeout();
    // });
  }



  loggeOut() {
    return new Promise((resolve, reject) => {
     this.httpClient.post(`/Account/LogOff`, {}).subscribe((res) => {
      this.cookieService.removeAll();
      localStorage.removeItem('coreIntegration');
      localStorage.removeItem('coreToken');
      localStorage.removeItem('coreRefreshToken');
      localStorage.removeItem('coreSessionId');
      localStorage.removeItem('coreUsername');
      localStorage.removeItem('userData');
      this.cookieService.remove('admin_access_token');
      this.cookieService.remove('admin_refresh_token');
    
      this.router.navigate(['login']);

      resolve(true);
    })
  })
  }


  sessionTimeout() {
    this.cookieService.remove('admin_access_token');
    this.cookieService.remove('admin_refresh_token');
    this.openNotifyError("Your session has timeout")
    this.router.navigate(['login']);
  }

  getLoggedUser(): any {
    if (this.isLoggedIn()) {
      var token = this.cookieService.get('admin_access_token')
      let decodedToken: any = jwt_decode(token);

      let userInfo = {
        fullName: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'],
        id: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
        email: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
        roleIds:decodedToken.RoleIds?decodedToken.RoleIds.split(","):[]

      }

      var UserInfo = userInfo;

      var userData = JSON.parse(localStorage.getItem('userData'))
      if(!userData){
        return { ...UserInfo}
      }
      userData.DefaultSiteInfo = userData.DefaultSiteInfo || {};
      userData.DefaultSiteInfo.Culture = userData.Culture;

      return {
        Roleid: userData.Role.id, roleName: decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'], rol: userData.Role, siteCultures: userData.DefaultSiteCultures,
        siteId: userData.DefaultSiteInfo.siteId, site: userData.DefaultSiteInfo, ...UserInfo, RoleInfo: userData.RoleInfo
      }
    } else
      return {}

  }


  checkRole(roleList: string, minRoleCheck?: boolean) {

    this.user = this.getLoggedUser()
    var found = true;
    var optionList = [];

    var elementRoles = roleList.split(',')
    for (let i = 0; i < elementRoles.length; i++) {
      const r = elementRoles[i];
      optionList.push(r)
    }

    if (minRoleCheck) {
      found = false;

      for (let i = 0; i < optionList.length; i++) {
        const o = optionList[i];
        if (this.checkOptionInRole(o)) {
          return true;
        }
      }

    }
    else {
      for (let i = 0; i < optionList.length; i++) {
        const o = optionList[i];

        if (!this.checkOptionInRole(o)) {
          found = false;
          break;
        }
      }
    }

    if (!found) {
      this.router.navigate(['404']);
    } else
      return found;

  }


  checkOptionInRole(code) {
    if (this.user && this.user.RoleInfo) {

      for (let i = 0; i < this.user.RoleInfo.length; i++) {
        const role = this.user.RoleInfo[i];
        if (role == code) {
          return true;
        }
      }
      return false;
    }
  }

  getJwtToken() {
    return localStorage.getItem('admin_access_token');
  }
  saveDeviceToken(token){

    const data={
      "deviceToken": token
    }

     this.httpClient.post(`/admin/UpdateDeviceToken`,data).toPromise().then()
  }
}


